export class CouponHelper{
  translateName = (name, lang, position) => {
    name = this.getTitle(name, lang)

    var extraText = ''
    if (lang == 'en' && name == "全国旅行支援") {
      return "National Travel Support Campaign"
    }

    if (lang == 'zh-TW' && name == "全国旅行支援") {
      switch (position) {
      case 'search_condition':
        return '僅顯示適用於全國旅行支援優惠的住宿'
      case "listing_item":
        return '全國旅行支援優惠的住宿'
      default:
        return '全國旅行支援'
      }
    }

    switch (position) {
    case 'search_condition':
      extraText = '対象施設のみ'
      break
    case "listing_item":
      extraText = '対象施設'
      break
    }

    return name.replace(/クーポン$/, '') + extraText
  }

  getTitle = (title, lang) => {
    if (typeof title === 'object') {
      if (title.hasOwnProperty(lang)) {
        return title[lang]
      } else {
        return title['ja']
      }
    } else {
      return title
    }
  }
}

const couponHelper = new CouponHelper()
export default couponHelper
